import React from 'react';
import { styled, Divider as MuiDivider } from '@mui/material';
import clsx from 'clsx';
import { omit } from 'lodash-es';
import { dividerClasses, getStyle } from './style';
const DividerBase = (props) => {
    const { orientation = 'horizontal', fullHeight = false, orientationMargin, className, sx, } = props;
    return (React.createElement(MuiDivider, { className: className, classes: {
            root: clsx(dividerClasses.root, {
                [`${dividerClasses.fullHeight}`]: fullHeight && orientation === 'vertical',
                [`${dividerClasses.horizontal}`]: orientation === 'horizontal',
                [`${dividerClasses.vertical}`]: orientation === 'vertical',
                orientationMargin: Boolean(orientationMargin) || orientationMargin === 0,
            }),
            textAlignLeft: dividerClasses.textAlignLeft,
            textAlignRight: dividerClasses.textAlignRight,
            wrapper: dividerClasses.wrapper,
            flexItem: dividerClasses.flexItem,
            withChildren: dividerClasses.withChildren,
            withChildrenVertical: dividerClasses.withChildrenVertical,
        }, ...omit(props, [
            'fullHeight',
            'dashed',
            'orientationMargin',
            'unit',
            'style',
        ]), sx: sx }));
};
const StyledDivider = styled(DividerBase)((props) => {
    const { theme, ...rest } = props;
    return getStyle(theme, rest);
});
const Divider = React.forwardRef((props, ref) => (React.createElement(StyledDivider, { ...props, ref: ref })));
export default Divider;
